
var quantityHelper = require('../quantitySelectorHelper');
var quickViewHelper = require('./quickViewHelper');
var quickViewHelperSlick = require('../helpers/quickviewSlickHelper');
var constants = require('../constants');
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var focusHelper = require('base/components/focus');
var utils = require('../utils');
var quickView = require('./quickViewPdp');
var editquickViewContainerId = '#editProductModal';
var verifyOOSIfRequired = require('antavo_custom/cart/verifyOOS').verifyOOSIfRequired;

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }

    var htmlString =
        `<!-- Modal -->
        <div class="modal modal-animated slide-in" id="editProductModal" role="dialog">
            <span class="enter-message sr-only"></span>
            <div class="modal-dialog quick-view-dialog quickview__modal">
                <!-- Modal content-->
                <div class="modal-content quickview__modal--content">
                <div class="modal-close">
                <button type="button" class="close" data-dismiss="modal">
                <span class="icon-close"></span>
                <span class="sr-only"> </span>
                </button>
                </div>
                <div class="modal-body quickview__modal__body"></div>
                </div>
            </div>
        </div>
        `;

    $('body').append(htmlString);
}

/**
 * Update Badges
 *
 * @param {Object} responseData - Data response from AJAX call
 */
function updateBadges(responseData) {
    var siteData = $('.page').data('sitename');
    var availabilityValue = '';
    var preOrderStatus = '';
    var availabilityMessages = responseData.availability.messages;
    var imgbadges = '';
    var stockBadges = '';
    var saleBadges = '';
    var responseMessage = responseData.badgeSkuLevelStatus.preOrderMessage;
    var responseMessageDate = responseData.badgeSkuLevelStatus.preOrderMessageDate;
    if (responseData.badgeSkuLevelStatus.preOrderStatus) {
        preOrderStatus += '<div class="pre-order"> <span>' + responseMessage + '</span> <span class="pre-order-date">' + responseMessageDate + '</span> </div>';
    }
    availabilityMessages.forEach(function (message) {
        if (responseData.badgeSkuLevelStatus.availabilityStatus) {
            var errMsg = $('.js-sold-out-container').data('errmsg');
            if (message === errMsg) {
                $('.js-sold-out-txt').addClass('d-none');
                var $qbbMobile = $('.js-sku-oos');
                if ($qbbMobile.length) {
                    $qbbMobile.addClass('d-none');
                }
                availabilityValue += '<li><span class="sold-out-sku">' + constants.messages.MESSAGE_SOLD_OUT + '</span><span class="other-sku-in-stock"> ' + constants.messages.MESSAGE_OTHER_SKU_INSTOCK + '</span></li>';
            } else if (responseData.available) {
                availabilityValue += '<li><span>' + message + '</span></li>';
            }
        }
    });

    availabilityMessageExists = availabilityValue && responseData.readyToOrder;

    imgbadges = utils.quickViewBadges(responseData);
    // else if (responseData.ImagebadgeSkuLevelStatus.preOrderStatus) {
    //     imgbadges += responseData.ImagebadgeSkuLevelStatus.preOrderBadge;
    //     imgbadges += responseData.badgeSkuLevelStatus.newBadge || responseData.badgeSkuLevelStatus.imageBadge1 || responseData.badgeSkuLevelStatus.imageBadge2 ? ' , ' : '';
    // }

    if (!responseData.badgeSkuLevelStatus.availabilityStatus && responseData.availability.inStockValue.length !== 0) {
        stockBadges += `<div class="product-detail__salebadges-text inventory-msg"> ${responseData.availability.inStockValue} </div>`;
    }
    if (responseData.badgeSkuLevelStatus.finalSalestatus) {
        if (siteData === 'PVHTHUS') {
            saleBadges += '<div class="custom-error product-detail__salebadges-text quickview__modal__body--finalBadge"><span class="finale-sale-label">' + constants.messages.FINAL_SALE + '</span> <span class="finale-sale-msg">' + constants.messages.FINAL_SALE_MESSAGE + '</span> </div>';
        } else {
            saleBadges += '<div class="custom-error product-detail__salebadges-text quickview__modal__body--finalBadge">' + responseData.badgeSkuLevelStatus.finalSaleBadge + '</div>';
        }
    }
    if (responseData.readyToOrder) {
        $('.availability-msg').removeClass('error').empty().html(availabilityValue);
    } else {
        $('.availability-msg').empty();
    }
    $('.preorder-status').empty().html(preOrderStatus);
    $('.product-detail__imgbadges').empty().html(imgbadges);
    $('.product-detail__stockBadges').empty().html(stockBadges);
    $('.product-detail__salebadges').empty().html(saleBadges);
}

/**
 * display OOS message when all the skus are OOS for a color
 * @param {Object} data - object
*/
function updateOosMessage(data) {
    var $displayColorOosMessage = $('.display-color-oos-message');
    if (data.selectedColorOOS) {
        var message = '<svg><use xlink:href="#alert-red"></use></svg><span class="color-oos-message"> ' + constants.messages.MESSAGE_COLOR_OOS + '</span>';
        $displayColorOosMessage.removeClass('d-none').append(message);
    } else {
        $displayColorOosMessage.empty().addClass('d-none');
    }
}
/**
 * Hiding Sold Out Msg container and enabeling availability container for QuickView Panel
 */
function enableAvailabilityContainer() {
    $('.js-sold-out-container').addClass('d-none');
    $('.js-price-container').removeClass('d-none');
    $('.js-availability-container').removeClass('d-none');
}


/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.quickViewBody');
    return { body: body };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 * @param {jQuery} dataTarget - target container
 */
function fillModalElement(editProductUrl, dataTarget) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl + '&showQuickView=true',
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);
            $('#editProductModal .modal-body').empty().html(parsedHtml.body);
            $('#editProductModal .quickview__modal__footer').html(parsedHtml.footer);
            $('#editProductModal .full-pdp-link').text('View Details');
            $('#editProductModal .full-pdp-link').attr('href', data.product.pdpurl);
            $('#editProductModal .full-pdp-star-rating-link').attr('href', data.product.pdpurl);
            $('#editProductModal h1.quickview__modal__head--name').html(
                '<a class="quickview__modal-heading-link" href=' + data.product.pdpurl + '>' + data.product.productName + '</a>'
            );
            let quickViewHeadHref = $('#editProductModal h1.quickview__modal__head--name a, #editProductModal .full-pdp-link').attr('href');
            let journeySeparator = quickViewHeadHref.indexOf('?') === -1 ? '?' : '&';
            let journeyHref = quickViewHeadHref + journeySeparator + 'journey=' + encodeURIComponent(data.journey || '');
            $('#editProductModal h1.quickview__modal__head--name a').attr('href', journeyHref).focus();
            $('#editProductModal .full-pdp-link').attr('href', quickViewHeadHref + '&journey=' + data.journey);
            $('#editProductModal .size-chart').attr('href', data.productUrl);
            $('#editProductModal .modal-close .close .sr-only').text(
                data.closeButtonText
            );
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('body').trigger(constants.events.EDIT_PRODUCT_MODAL_READY);
            quickViewHelperSlick.quickviewSlick();
            updateBadges(data.product);
            quickViewHelperSlick.updateImages(data.product);
            updateOosMessage(data);
            if (data.product.isOneSizeProduct) {
                $('.update-cart-product-global').attr('data-cur-pid', data.product.oneSizeSKUID);
                $('.update-cart-product-global').attr('data-pid', data.product.oneSizeSKUID);
            }
            var escapedTarget = $('<div>').text(dataTarget).html();
            quickViewHelper.updateProductURL(data.product, $(escapedTarget));
            utils.disableButton($('button.update-cart-product-global'), data.product.price.salesDisplayPrice);
            utils.openModal($(escapedTarget));
            $.spinner().stop();
            productGlobalVariable = data.product;
            tealiumEnable.getAnalyticsData('editProduct', data);
            // check for OOS color swatches onload
            var colorCodes = $('.variant-colorCode');
            utils.oosColorSwatches(data.product.variationAttributes, colorCodes);
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * main method for opening edit modal
 * @param {string} editProductUrl product edit urlParams
 * @param {string} dataTarget target element
 */
function openEditModal(editProductUrl, dataTarget) {
    getModalHtmlElement();
    fillModalElement(editProductUrl, dataTarget);
}


/**
 * Handle Swatch Attributes
 * @param {Object} attrValue - Data response from AJAX call
 * @param {Object} attr - Data response from AJAX call
 * @param {Object} $attrValue - Data response from AJAX call
 * @param {boolean} strikeThroughStatus -
 */
// eslint-disable-next-line
function swatchAttrUpdate(attrValue, attr, $attrValue, strikeThroughStatus) {
    if (attrValue.selected) {
        $('h3.' + attr.id).html(
            '<span class="variation__attr--name">' + attr.displayName + '</span><span class="variation__attr--value">' + attr.displayValue + '</span>'
        );
        $attrValue.attr('aria-checked', 'true');
    } else {
        $attrValue.attr('aria-checked', 'false');
    }

    if (attrValue.url) {
        $attrValue.attr('data-url', attrValue.url);
    } else {
        $attrValue.removeAttr('data-url');
    }

    if (!attrValue.selectable) {
        if (!strikeThroughStatus) {
            $attrValue.css('display', 'none');
        }
    } else {
        $attrValue.css('display', 'flex');
    }
}

/**
 * Process attribute values in QBB associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {boolean} strikeThroughStatus - Having strikeThroughStatus true or false selected.
 */
function renderNonSwatchValuesQBB(attr, strikeThroughStatus) {
    var nonSwatchValues = '';
    attr.values.forEach(function (attrValue, index) {
        if (!(!strikeThroughStatus && !attrValue.selectable)) {
            // eslint-disable-next-line
            var disableState = !attrValue.selectable ? `disabled` : ``;
            // eslint-disable-next-line
            nonSwatchValues += `<input type="radio" id="` + attr.id + `qitem` + index + `" class='` + attr.id + `quick` + index + strikeThroughStatus + ` quickbuy--variant-item ds-radio-size variant-` + attr.id + `' role='radio' data-display-id='` + attr.id + `' aria-checked="` + attrValue.selected + `" aria-label="` + attrValue.displayName + `" data-attr-value="` + attrValue.value + `" data-url="` + attrValue.url + `" tabindex="0" ` + disableState + `/>
            <label for="` + attr.id + `qitem` + index + `">` + attrValue.displayValue + `</label>`;  //eslint-disable-line
        }
    });
    $('.attribute-' + attr.id + ' .quickbuy--variant-selector-container ul#qsizes').html(nonSwatchValues);
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 * @param {boolean} strikeThroughStatus - Having strikeThroughStatus true or false
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, strikeThroughStatus) {
    renderNonSwatchValuesQBB(attr, strikeThroughStatus);
    attr.values.forEach(function (attrValue, index) {
        var $attrValue = $('#' + attr.id + 'item' + index);
        var $qattrValue = $('.' + attr.id + 'quick' + index);
        var $attrqValue = $('#' + attr.id + 'qitem' + index);
        if (attrValue.selected) {
            $('h3.' + attr.id).html('<span class="variation__attr--name">' + attr.displayName + '</span><span class="variation__attr--value">' + attr.displayValue + '</span>');
            $attrValue.attr('aria-checked', 'true');
            $attrqValue.attr('aria-checked', 'true');
        } else {
            $attrValue.attr('aria-checked', 'false');
            $attrqValue.attr('aria-checked', 'false');
        }

        if (attrValue.url) {
            $attrValue.attr('data-url', attrValue.url);
            $qattrValue.attr('data-url', attrValue.url);
        } else {
            $attrValue.removeAttr('data-url');
            $qattrValue.removeAttr('data-url');
        }

        if (!attrValue.selectable) {
            if (!strikeThroughStatus) {
                $attrValue.css('display', 'none');
            } else {
                // $attrValue.attr('disabled', '');
                $attrValue.addClass('disabled oos-variant');
                $qattrValue.attr('disabled', '');
                $attrValue.attr('tabindex', '-1');
            }
        } else {
            // $attrValue.removeAttr('disabled');
            $attrValue.removeClass('disabled oos-variant');
            $qattrValue.removeAttr('disabled');
            $attrValue.css('display', 'flex');
            $attrValue.attr('tabindex', '0');
        }
    });
}


/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {boolean} strikeThroughStatus - Having strikeThroughStatus true or false
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, strikeThroughStatus) {
    attrs.forEach(function (attr) {
        if (attr.swatchable) {
            quickViewHelper.processSwatchValues(attr, strikeThroughStatus);
        } else {
            processNonSwatchValues(attr, strikeThroughStatus);
        }
        if (!attr.swatchable && attr.displayValue === '') {
            $(`h3.${attr.attributeId}`).html(`Select ${attr.displayName}`);
        }
    });
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 */
function handleVariantResponse(response) {
    if (response.product.variationAttributes) {
        updateAttrs(
            response.product.variationAttributes,
            response.product.strikeThroughStatus
        );
    }
    // Update Promotions
    $('.quickview__modal__body--inner').find('.product-promotions').empty().html(response.product.promotionsHtml);
    // eslint-disable-next-line no-unused-vars
    var $buttonLabelInput = $('.update-button-label');
    var priceVal = response.product.price.type === 'range' ? response.product.price.salesDisplayRange : response.product.price.salesDisplayPrice;
    var buttonLabel = `${$buttonLabelInput.val()} - ${priceVal}`; // eslint-disable-line
    if (!response.product.orderable) {
        buttonLabel = `${$buttonLabelInput.val()}`;
    }

    $('#editProductModal h1.quickview__modal__head--name').html(
        '<a class="quickview__modal-heading-link" href=' + response.product.selectedProductUrl + '>' + response.product.productName + '</a>'
    );
    $('#editProductModal .full-pdp-link').attr('href', response.product.selectedProductUrl);
    quickViewHelperSlick.updateImages(response.product);
    $('.quickview__modal__body--prices').empty().html(response.product.price.html);
    if (!response.product.orderable) {
        $('.quickview__modal__body--prices .sales .value').html(constants.messages.OOS_status);
    }
    $('.product-detail__prices').empty().html(response.product.price.html);
    $(
        'button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global'
    )
        .trigger('product:updateAddToCart', {
            product: response.product
        })
        .trigger('product:statusUpdate', response.product);
    // Update antavo points
    if (response.product.antavoPoints) {
        $('#editProductModal').find('.antavo-points').empty().html(response.product.antavoPoints);
    }

    // Update antavo multiplier
    $('#editProductModal').find('.wrapper-antavo-multiflier').empty();
    if (response.product.antavoPointsMultiplier > 1) {
        let $multiplierHtml = `<span class="antavo-multiflier">${response.product.antavoPointsMultiplier}X</span>`;
        $('#editProductModal').find('.wrapper-antavo-multiflier').append($multiplierHtml);
    }
    // Hide 'UPTO' text when a size is selected
    if (response.product.price.type === 'range') {
        $('#editProductModal').find('.text-more span').show();
    } else {
        $('#editProductModal').find('.text-more span').hide();
    }
}

/**
 * Update quick buy bar container
 *
 * @param {Object} data - Response object
 */
function updateQuickBuy(data) {
    var prodImageQbb;
    if (data.product.images.large.length > 0) {
        prodImageQbb = utils.renderPictureTag(data.product.images.large[0], { devices: { mobile: data.product.imageDimentions.desktop.product }, className: 'product-image' });
    } else {
        prodImageQbb = '<img class="product-image" src="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAQAAADIpIVQAAAAEUlEQVR42mP89Z8BDBiJYAAA/CsJ44FW0NkAAAAASUVORK5CYII=" alt="" onerror="onImageError($(this));" />';
    }
    $('.quickbuyMob--image__wrapper').html(prodImageQbb);
}

/**
 *
function to handle previous error response from server
 * @param {string} attributeId - attribute ID
 * @param {jQuery} $productContainer - DOM element for current product
 */
function handlePreviousErrorResponse(attributeId, $productContainer) {
    if (attributeId) {
        $productContainer.find('.' + attributeId + ' span.variation__attr--name').removeClass('modal-error-color');
        $productContainer.find('input:not([disabled])[type="radio"].ds-radio-size.variant-' + attributeId + ' + label').removeClass('modal-error-border');
        $productContainer.find('.variant-error-' + attributeId).addClass('hide');
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {string} productContainer - product container target
 * @param {string} eventName - tealium event name
 * @param {string} selectedAttrId - selected attribute ID
 */
function attributeSelect(selectedValueUrl, productContainer, eventName, selectedAttrId) {
    if (selectedValueUrl) {
        var $quickViewModalContent = $('.quickview__modal--content').length > 0 ? $('.quickview__modal--content') : $('.quickeditview-container');
        $quickViewModalContent.addClass('qv-lock');
        $.ajax({
            url: selectedValueUrl + '&showQuickView=true',
            method: 'GET',
            success: function (data) {
                var quickViewModalPos = $quickViewModalContent.scrollTop();
                var updateCartProductGlobal = $('.update-cart-product-global');
                var cartActionsContainer = $('.quickview__modal__footer .cart-and-ipay');
                var productId = productContainer.data('pid');
                var oosButton = constants.messages.MESSAGE_CTA_OOS;
                var updateBag = constants.messages.MESSAGE_CTA_UPDATE;
                handleVariantResponse(data);
                $('.error-text').remove();
                updateBadges(data.product);
                updateOosMessage(data);
                quickViewHelper.updateProductURL(data.product, productContainer);
                handlePreviousErrorResponse(selectedAttrId, productContainer);
                quantityHelper.updateQuantities(data.product, productContainer, productId);
                updateQuickBuy(data);
                updateCartProductGlobal.attr('data-uuid', data.product.uuid);
                var colorCodes = $('.variant-colorCode');
                utils.oosColorSwatches(data.product.variationAttributes, colorCodes);
                if (data.product.isOneSizeProduct) {
                    updateCartProductGlobal.attr('data-cur-pid', data.product.oneSizeSKUID);
                    updateCartProductGlobal.attr('data-pid', data.product.oneSizeSKUID);
                    updateCartProductGlobal.attr('data-readytoorder', true);
                } else {
                    updateCartProductGlobal.attr('data-cur-pid', data.product.id);
                }
                updateCartProductGlobal.attr('data-category-id', data.product.productCgId);
                $('.modal.show .full-pdp-link').attr('href', data.product.selectedProductUrl);
                $quickViewModalContent.scrollTop(quickViewModalPos);
                $quickViewModalContent.removeClass('qv-lock');
                $('.quickview__modal__head--name').html(
                    '<a class="quickview__modal-heading-link" href=' + data.product.pdpurl + '>' + data.product.productName + '</a>'
                );
                var isSizeSelected;
                var variantItemAria = $('.variant-item[aria-checked="true"]');
                isSizeSelected = variantItemAria.length === data.product.variationAttributes.length - 1
                    ? variantItemAria.hasClass('disabled')
                    : false;
                var isAvailability = data.product.available;
                if (data.product.orderable) {
                    updateCartProductGlobal.empty().html(updateBag + ' - ' + data.product.price.salesDisplayPrice).removeAttr('disabled');
                    cartActionsContainer.removeClass('qv-footer-oos');
                } else {
                    updateCartProductGlobal.empty().html(oosButton).prop('disabled', true);
                    cartActionsContainer.addClass('qv-footer-oos');
                }
                enableAvailabilityContainer();
                if (data.product.readyToOrder && data.product.available) {
                    updateCartProductGlobal.empty().html(updateBag + ' - ' + data.product.price.salesDisplayPrice).removeAttr('disabled');
                    cartActionsContainer.removeClass('qv-footer-oos');
                } else if (isSizeSelected) {
                    updateCartProductGlobal.empty().html(oosButton).prop('disabled', true);
                    cartActionsContainer.addClass('qv-footer-oos');
                } else if (isAvailability) {
                    // condition for color only url reset to update ATC CTA text and state
                    updateCartProductGlobal.empty().html(constants.messages.MESSAGE_SELECT_SIZE).removeAttr('disabled');
                    cartActionsContainer.removeClass('qv-footer-oos');
                } else {
                    updateCartProductGlobal.empty().html(oosButton).prop('disabled', true);
                    cartActionsContainer.addClass('qv-footer-oos');
                }
                var eventNameCopy = eventName;
                // price null check on UpdateBag CTA
                utils.disableButton($('button.update-cart-product-global'), data.product.price.salesDisplayPrice);
                // Re-apply disabled if button is showing OOS text
                if ($('button.update-cart-product-global').text().trim() === oosButton) {
                    $('button.update-cart-product-global').prop('disabled', true);
                }
                data.product.variationAttributes.forEach(variationAttribute => {
                    var selectedAttrValue = variationAttribute.displayValue;
                    variationAttribute.values.forEach(value => {
                        if (selectedAttrValue === value.displayValue && !value.selectable) {
                            eventNameCopy += ',product_upc_color_size_combo_sold_out';
                        }
                    });
                });

                if (eventNameCopy !== '') {
                    tealiumEnable.getAnalyticsData('getVariationSelectedData', data.product, eventNameCopy, 'cart');
                }
                // check for available inventory and update button state
                if ((data.product.maxQuantityAllowed < data.product.selectedQuantity) && ($('#select-variantQty-' + data.product.maxQuantityAllowed)).attr('selected')) {
                    updateCartProductGlobal.removeAttr('disabled').empty().text(updateBag + ' - ' + data.product.price.salesDisplayPrice);
                    cartActionsContainer.removeClass('qv-footer-oos');
                }
            },
            error: function () {
                $quickViewModalContent.spinner().stop();
            }
        });
    }
}

/**
 * @param {Object} $errorMsgElement - Msg element for error message
 * @param {Object} $varientSizeSelector - Border element for size selector
 * @param {string} borderErrorClass - Error border class for size selector
 */
function showVariationError($errorMsgElement, $varientSizeSelector, borderErrorClass) {
    $errorMsgElement.show();
    $varientSizeSelector.addClass(borderErrorClass);
}

/**
 * @param {Object} $errorMsgElement - Msg element for error message
 * @param {Object} $varientSizeSelector - Border element for size selector
 * @param {string} borderErrorClass - Error border class for size selector
 */
function hideVariationError($errorMsgElement, $varientSizeSelector, borderErrorClass) {
    $errorMsgElement.hide();
    $varientSizeSelector.removeClass(borderErrorClass);
}

/**
 * Handles the errors for the variation categories
 */
function handleVariantErrorMessage() {
    var $modalVarientElement;
    var $varientSizeSelector;
    var errorMsgSelector = '.variant-error';
    var borderErrorClass = 'modal-error-border';
    var $errorMsgElement;
    var $this;

    $('#editProductModal .variant-list').each(function () {
        $this = $(this);
        if ($this.hasClass('colors-variant-list')) {
            return;
        }
        var modeOfVariant = $this.data('display-id');
        if ($this.has('.variant-item[aria-checked="true"], .quickbuy--variant-item[aria-checked="true"], .variant-color-item[aria-checked="true"]').length) {
            $('li[role="radio"].variant-' + modeOfVariant).removeClass('modal-error-border');
            $this.closest('#pdpAttribute').find('.variant-error').hide();
        } else {
            $('li[role="radio"].variant-' + modeOfVariant).addClass('modal-error-border');
            $('input[role="radio"].variant-' + modeOfVariant).addClass('modal-error-border');
            $('input:not([disabled])[type="radio"].ds-radio-size.variant-' + modeOfVariant + ' + label').addClass('modal-error-border');
        }
    });

    $modalVarientElement = $('#editProductModal .variant-list');
    $varientSizeSelector = $('.variant-item--quickview.variant-item.variant-size');

    $modalVarientElement.each(function () {
        $this = $(this);
        if ($this.hasClass('colors-variant-list')) {
            return;
        }
        $errorMsgElement = $this.closest('#pdpAttribute').find(errorMsgSelector);
        if ($this.has('.variant-item[aria-checked="true"], .variant-color-item[aria-checked="true"]').length) {
            hideVariationError($errorMsgElement, $varientSizeSelector, borderErrorClass);
        } else {
            showVariationError($errorMsgElement, $varientSizeSelector, borderErrorClass);
        }
    });
}

/**
 *
 function to handle validation UI on Quantity Select
 * @param {string} modeOfVariant - when user clicks on the add to bag button without selecting size then gives the value as size in string
 * @param {jQuery} $qbbAttribute - DOM element attributes
 */
// eslint-disable-next-line
function updateVariantOnQuantitySelectorStatus(modeOfVariant, modeOfVariantValue, $qbbAttribute) {
    const isVariantLabelAvailable = $qbbAttribute.find('label.' + modeOfVariant).html();
    if ($qbbAttribute.find('.' + modeOfVariant).html()) {
        if (isVariantLabelAvailable.toLowerCase() === 'select ' + modeOfVariantValue.toLowerCase() + '') {
            $qbbAttribute.find('.' + modeOfVariant + ' span.variation__attr--name').addClass('modal-error-color');
            $qbbAttribute.find('input:not([disabled])[type="radio"].ds-radio-size.variant-' + modeOfVariant + ' + label').addClass('modal-error-border');
            $qbbAttribute.find('.variant-error-' + modeOfVariant).removeClass('hide');
        }
    }
}

/**
 * Handles error response
 * @param {Object} err - Error object
 */
function errorRes(err) {
    if (err.responseJSON.redirectUrl) {
        window.location.href = err.responseJSON.redirectUrl;
    } else {
        if (err && err.responseJSON && err.responseJSON.errorMessage) {
            utils.createErrorNotification(err.responseJSON.errorMessage);
        }
        $.spinner().stop();
    }
}

/**
 * Loads updated product list
 * @param {string} pid - product id
 */
function loadUpdatedProductListByUrl(pid) {
    const $cartListUrl = $('.cart-list-url').val();
    const $targetContainer = $('.shopping-bag__list');
    $.ajax({
        url: $cartListUrl,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            $.spinner().stop();
            $targetContainer.html(data.renderTemplate);
            var noQtyError = !data.qtyValid || (data.qtyValid && !data.qtyValid.error);
            $('.cartmerge-error').addClass('d-none');
            if ($('div.ds-cart-error-messaging').length && !data.valid.error && noQtyError) {
                $('.cart-error-messaging').addClass('d-none');
                $('.buttonErrorMessage').addClass('d-none');
            } else if ($('div.ds-cart-error-messaging').length && !noQtyError) {
                $('.cart-qty-error .cart-error_message').empty().append(data.qtyValid.message);
                $('.cart-qty-error').removeClass('d-none');
                $('html, body').animate({ scrollTop: 0 }, 200);
            }

            if (data.items.length) {
                const $cartPage = $('.cart');
                if (data.action.indexOf('Cart') !== -1) {
                    if (!$('.loyalty-info-message .tooltip-wrapper').length) {
                        if (data.antavoRewardPoints && data.antavoRewardPoints.points >= 0) {
                            var html = '<input type="hidden" class="loyalty-info-message-points" value="' + data.antavoRewardPoints.points + '" />';
                            $('.loyalty-info-message .tooltip-wrapper').empty().append(html);
                            $('.order-summary-container .loyalty-rewards-box-model-cart .points-display, .device-summary-msg .loyalty-rewards-box-model-cart .points-display').html(data.antavoRewardPoints.points);
                            $('.order-summary-container, .device-loyalty-pointscontainer').removeClass('hide-antavo-copy');
                            if (data.antavoRewardPoints.points === 0) {
                                $('.order-summary-container, .device-loyalty-pointscontainer').addClass('hide-antavo-copy');
                            }
                        }
                    }
                    $cartPage.addClass('has-cart-items, cart-page');
                    $('.shipping--intro').removeClass('d-none');
                    $cartPage.removeClass('cart-empty');
                    var event = 'cart_add';
                    tealiumEnable.getAnalyticsData('moveToBagEvent', pid, data, event);
                }
            } else {
                const $cartPage = $('.cart');
                $cartPage.removeClass('has-cart-items, cart-page');
                $('.shipping--intro').addClass('d-none');
                $cartPage.addClass('cart-empty');
            }
        }
    });
}

/**
 * handle all edit modal events
 */
function handleEditModalEvents() {
    $('body').on('click', '.product-edit .edit, .bundle-edit .edit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var editProductUrl = $(this).attr('data-url');
        var dataTarget = $(this).attr('data-target');
        openEditModal(editProductUrl, dataTarget);

        const modalClass = $(this).data('modal-class');
        if (modalClass) {
            $('#editProductModal').addClass(modalClass);  // Add the unique class to the modal for SFL
        }
    });

    $(document).on('click keydown', `${editquickViewContainerId} .variant-color-item:not([disabled],[aria-checked="true"]), ${editquickViewContainerId} .quickbuy--variant-color-item:not([disabled],[aria-checked="true"])`, function (e) {
        if (e.key === 'Enter' || e.type === 'click') {
            e.preventDefault();
            var $productContainer = $(editquickViewContainerId + ' .product-detail');
            var selectedValueUrl = $(this).attr('data-url');
            var selectedAttrId = $(this).attr('data-display-id');

            // send color only url to reset size selection for multi-demension products and non-available sizes
            if ($(this).hasClass('oss-color')) {
                if ($('.attribute-item.swatch').length > 2 || $('.quickview__modal__body--attribute').hasClass('strike-through-false')) {
                    selectedValueUrl = $(this).data('url-color');
                }
            }
            $(this).siblings('.variant-color-item').attr('aria-checked', 'false');
            var eventName = 'product_change_color';
            attributeSelect(selectedValueUrl, $productContainer, eventName, selectedAttrId);
            var $quickViewModalContent = $('.quickview__modal--content').length > 0 ? $('.quickview__modal--content') : $('.quickeditview-container'); // eslint-disable-line
        }
    });

    $(document).on('click keydown', `${editquickViewContainerId} .variant-item:not([disabled],[aria-checked="true"]), ${editquickViewContainerId} .quickbuy--variant-item:not([disabled],[aria-checked="true"])`, function (e) {
        if (e.key === 'Enter' || e.type === 'click') {
            e.preventDefault();
            var $productContainer = $(editquickViewContainerId + ' .product-detail');
            var selectedValueUrl = $(this).attr('data-url');
            var selectedAttrId = $(this).attr('data-display-id');
            var eventName = 'product_change_size';
            attributeSelect(selectedValueUrl, $productContainer, eventName, selectedAttrId);
        }
    });

    $(document).on('change', `${editquickViewContainerId} .quantity-dropdown select`, function (e) {
        e.preventDefault();
        var $productContainer = $(editquickViewContainerId + ' .product-detail');
        var selectedValueUrl = $('option:selected', $(this)).data('url');
        var selectedAttrId = $(this).attr('data-display-id');
        if (quantityHelper.isProductSetavailable()) {
            $productContainer = $(this).closest('.set-item.productSet-wrapper');
        }
        var eventName = '';
        attributeSelect(selectedValueUrl, $productContainer, eventName, selectedAttrId);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        const $modal = $('#editProductModal');
        $modal.siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').trigger('focus');
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
        if ($('#editProductModal').length !== 0) {
            $('#editProductModal').remove();
        }
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
        // TurnTo Integration
        TurnToCmd('set', { sku: response.data.product.id }); // eslint-disable-line new-cap
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');
        if ($('.variant-error:visible').length) {
            handleVariantErrorMessage(e);
        }
        $('.update-cart-product-global').attr('data-readytoorder', (response.product.readyToOrder));
        $('.update-cart-product-global', dialog).attr('disabled',
            !$('.global-availability', dialog).data('ready-to-order')
            || !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var $this = $(this);
        var updateProductUrl = $this.closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $('.quantity-dropdown option:selected').val();
        var selectedOptionValueId = $this.closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
        var uuid = $this.closest('.cart-and-ipay').find('.update-cart-url').data('uuid');
        var prev_pid = $this.attr('data-pid');
        var pid = $this.attr('data-cur-pid');
        var cgid = $(this).attr('data-category-id');
        var pageType = $this.attr('data-pagetype');
        var listtype = $('.quickview-listtype').data('listtype');
        var readyToOder = $this.attr('data-readytoorder');
        var csrf_token = $('.csrf-token').attr('data-csrf-value');
        var form = {
            uuid: uuid,
            ppid: prev_pid,
            pid: pid,
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId,
            csrf_token: csrf_token,
            pageType: pageType,
            cgid: cgid
        };
        if (listtype) {
            form.listtype = listtype;
        }
        // if ($('.update-cart-product-global').hasClass('quickview__modal__footer--cartBtn--mob')) {
        //     handleVariantError($this);
        // } else {

        // }
        quickView.handleVariantErrorMessage(e);

        $this.parents('.card').spinner().start();

        // TODO : Separate out update cart and update wishlist in future
        if (form.pageType === 'cart') {
            $('body').trigger('cart:beforeUpdate');
        } else if (form.pageType === 'wishlist') {
            $('body').trigger('wishlist:beforeUpdate');
        }
        if (updateProductUrl && readyToOder === 'true') {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    if (data.error && data.message) {
                        $('.error-text').remove();
                        var $errorElem = $(`<span class="error-text page-error max-quantity-error-item"><span class="icon-alert"></span>${data.message}</span>`);
                        $('.quickview__modal__footer').prepend($errorElem);
                        $.spinner().stop();
                        return;
                    }
                    verifyOOSIfRequired(data, function (updatedData) {
                        data = updatedData; // eslint-disable-line
                        $('#editProductModal').modal('hide');
                        if (form.pageType === 'cart') {
                            if (!data.cartModel && data.cart) {
                                data.cartModel = data.cart; // eslint-disable-line
                            }
                            $('body').trigger(constants.events.CART_ITEM_UPDATED, [data, uuid]);
                            loadUpdatedProductListByUrl(pid);
                            var eventName = 'cart_add,cart_add_quickbuysticky';
                            var product = data.cartModel.items;
                            product = product.filter(function (obj) {
                                return obj.id === data.newProductId;
                            });
                            tealiumEnable.getAnalyticsData('getAddToCartData', product ? product[0] : null, null, eventName);
                        } else if (form.pageType === 'wishlist') {
                            $('body').trigger(constants.events.WISHLIST_UPDATED, [data, uuid]);
                        }

                        if ($('.rewardlimitmessagewrapper').length) {
                            $('.rewardlimitmessagewrapper').addClass('hide');
                        }
                        var noQtyError = !data.cartModel.qtyValid || (data.cartModel.qtyValid && !data.cartModel.qtyValid.error);
                        $('.cartmerge-error').addClass('d-none');
                        if ($('div.ds-cart-error-messaging').length && !data.cartModel.valid.error && noQtyError) {
                            $('.cart-error-messaging').addClass('d-none');
                            $('.buttonErrorMessage').addClass('d-none');
                        } else if ($('div.ds-cart-error-messaging').length && !noQtyError) {
                            $('.cart-qty-error .cart-error_message').empty().append(data.cartModel.qtyValid.message);
                            $('.cart-qty-error').removeClass('d-none');
                            $('html, body').animate({ scrollTop: 0 }, 200);
                        }

                        if ($('div.ds-cart-error-messaging').length && !data.cartModel.valid.mExclusiveError) {
                            $('.cart-exclusive-member-error').addClass('d-none');
                            $('.buttonErrorMessage').addClass('d-none');
                        }
                        tealiumEnable.getAnalyticsData('cartAutoUpdateProductEvent', data.cartModel);
                        if (pageType === 'cart') {
                            utils.uniformSpacing();
                        }
                        $.spinner().stop();
                    });
                },
                error: function (err) {
                    let message = err.responseJSON.message;
                    let errorHandling = function () {
                        var errorElem = `<span class="error-text page-error max-quantity-error-item"><span class="icon-alert"></span>${message}</span>`;
                        $('.error-text').remove();
                        $('.quickview__modal__footer').prepend(errorElem);
                        $('#quickViewModal .error-text').trigger('focus');
                        tealiumEnable.getAnalyticsData('serverError', err.responseJSON.errorCode);
                    };
                    if (err.responseJSON.csrfError) {
                        utils.handleCsrfToken(errorHandling);
                    } else {
                        errorRes(err);
                        errorHandling();
                    }
                }
            });
        }
    });

    $(document).on('click', '#editProductModal .js-quantitySelector', function (e) {
        let containerData = e.target.nodeName !== 'SELECT' ? $(e.target).siblings('select') : e.target;
        if ($(containerData).attr('disabled')) {
            handleVariantErrorMessage(e);
        }
    });
}

module.exports = {
    handleEditModalEvents
};
